export const GFV_DEFAULT_ANNUAL_KM = 15000

export interface BuybackReferenceRow {
  effective: string
  endDate: string
  year: number
  make: string
  model: string
  variant: string
  series: string
  rrp: number
  term: number
  annualKm: number
  insurableKm: number
  insuredValue: number
  autoNextFee: number
}
